import { FunctionComponent } from 'react'
import { LogoutRedirect } from 'src/component/auth/logout-redirect'

export const LogoutScreen: FunctionComponent = () => <LogoutRedirect />
